const { addFilter } = wp.hooks;
const { createHigherOrderComponent } = wp.compose;
const { Fragment } = wp.element;
const { BlockControls, AlignmentToolbar } = wp.blockEditor;
const { useEffect } = wp.element;
const { __ } = wp.i18n;
import { stretchFullWidth, stretchWide } from '@wordpress/icons';

const ALIGNMENT_CONTROLS = [
  {
		icon: stretchWide,
		title: __( 'Default' ),
		align: 'default',
	},
	{
		icon: stretchWide,
		title: __( 'Container' ),
		align: 'container',
	},
	{
		icon: stretchFullWidth,
		title: __( 'Full Width' ),
		align: 'full',
	},
];

const blockEditFunction = createHigherOrderComponent((BlockEdit) => {
  return (props) => {
    if ( props.name !== 'core/group' ) {
      return <BlockEdit {...props} />;
    }

    useEffect( () => {
      let existingClassNames = props.attributes.className ? props.attributes.className : '';
      existingClassNames = existingClassNames.split( ' ' );
      existingClassNames = existingClassNames.filter( classname => {
        return classname.trim() !== 'ubc-clf-full' && classname.trim() !== 'ubc-clf-container';
      } ).join( ' ' );

      let classname = '';
      switch (props.attributes.blockSize) {
          case 'full':
            classname = 'ubc-clf-full'
            break;
          case 'container':
            classname = 'ubc-clf-container'
            break;
      }

      props.setAttributes( {
        className: existingClassNames ? `${ existingClassNames } ${ classname }` : classname,
      } );

    }, [ props.attributes.blockSize ] )

    return (
      <Fragment>
        <BlockControls>
          <AlignmentToolbar
            value={ props.attributes.blockSize }
            label={ __( 'Change block layout' ) }
            alignmentControls = { ALIGNMENT_CONTROLS }
            onChange={ ( nextAlign ) => {
              props.setAttributes( { blockSize: nextAlign } );
            } }
          />
        </BlockControls>
        <BlockEdit {...props} />
      </Fragment>
    );
  };
}, "blockEdit");

addFilter("editor.BlockEdit", "ubc-group-full-width/blockEdit", blockEditFunction);
